




















import { AppTheme } from "@/common/models";
import { SharedState } from "@/common/state";
import { onMounted, Ref, ref, watch } from "@vue/composition-api";
import Vue from "vue";
export default Vue.extend({
  setup() {
    const app_logo: Ref<HTMLImageElement | null> = ref(null);

    const set_icon = (theme: AppTheme) => {
      const { icon, dark_icon } = SharedState.partner.value;
      const src = theme == "light" ? icon : dark_icon;
      app_logo.value && app_logo.value.setAttribute("src", src);
    };
    /* logo="@/assets/logo-full.svg"  */
    onMounted(() => {
      SharedState.onReady(async () => {
        watch(
          SharedState.theme,
          (current_theme) => {
            set_icon(current_theme);
          },
          { lazy: true }
        );

        set_icon(SharedState.theme.value);
      });
    });
    return { app_logo, home_page: location.origin };
  },
});
